import React, { Component } from "react";
import { observer } from "mobx-react";
import { Button, Card, Grid, Header, Segment } from "semantic-ui-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import CustomerTourCard from "./CustomerTourCard";

@observer
class CustomerToursList extends Component {
  render() {
    const { tours, infiniteLoadMore, loadMoreCallback, t } = this.props;

    return (
      <>
        {tours.length > 0 ? (
          <Card.Group itemsPerRow={4} className="ui centered doubling">
            {tours.map(tour => (
              <CustomerTourCard key={tour.tourId} tour={tour} />
            ))}
          </Card.Group>
        ) : (
          <Segment basic>
            <Segment placeholder>
              <Header icon className="ui huge text">
                {t("customerPortal:noTour")}
              </Header>
            </Segment>
          </Segment>
        )}
        {tours.length > 15 && infiniteLoadMore ? (
          <>
            <div className="ui basic segment" />
            <Grid textAlign="center">
              <Grid.Column>
                <Button onClick={loadMoreCallback} basic color="blue" content={t("customerPortal:seeMore")} />
              </Grid.Column>
            </Grid>
          </>
        ) : null}
      </>
    );
  }
}

CustomerToursList.propTypes = {
  infiniteLoadMore: PropTypes.bool,
  tours: PropTypes.array,
  loadMoreCallback: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CustomerToursList);
